export * from './IconCommentDeleteFilled';
